<template>
  <div class="asc-analytics">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AscAnalytics',
}
</script>
